<template>
    <crud-layout :title="title" :subtitle="subtitle" :add-button="true" @add="creating = true">

        <template v-slot:list>
            <Invira-roles-list
                    @update="openUpdate"
                    @delete="openDelete"
                    @copy="openCopy"
            ></Invira-roles-list>
        </template>

        <Invira-roles-copy v-if="!!roleToCopy"
                     :open="!!roleToCopy"
                     :role="roleToCopy"
                     :permissions="permissions"
                     :roles="roles"
                     v-on:close="roleToCopy=null"
                     v-on:roleCopied="onRoleCreated"
        />


        <Invira-roles-delete v-if="!!roleToDelete"
                     :open="!!roleToDelete"
                     :role="roleToDelete"
                     v-on:roleDeleted="onRoleDeleted"
                     v-on:close="roleToDelete=null"
        />

        <Invira-roles-create v-if="creating"
                     :open="creating"
                     v-on:roleCreated="onRoleCreated"
                     v-on:close="creating=false"
        />

        <snackbar v-model="flash"/>
    </crud-layout>
</template>

<script>
    import InviraRolesCopy from "../InviraRolesCopy";
    import InviraRolesDelete from "../InviraRolesDelete";
    import InviraRolesList from "../InviraRolesList";
    import InviraRolesCreate from "../InviraRolesCreate";
    import {CrudLayout, Snackbar} from "@dracul/common-frontend"

    export default {
        name: "InviraRolesCrud",
        components: {CrudLayout, Snackbar, InviraRolesList, InviraRolesCopy, InviraRolesDelete, InviraRolesCreate},
        data() {
            return {
                title: 'admin.inviraRole.title',
                subtitle: 'admin.inviraRole.subtitle',
                roleToCopy: null,
                roleToDelete: null,
                creating: false,
                flash: null
            }
        },
        methods: {
            openUpdate(role) {
                // Navigate to permissions page
                this.$router.push(`/Invira-roles-management/${role.id}/permissions`);
            },
            openCopy(role) {
                this.roleToCopy = role
            },
            openDelete(role) {
                this.roleToDelete = role
            },
            onRoleCreated() {
                this.flash = this.$t('admin.inviraRole.created')
                // Reload will be handled by the list component
            },
            onRoleDeleted() {
                this.flash = this.$t('admin.inviraRole.deleted')
                // Reload will be handled by the list component
            }
        }
    }
</script>

<style scoped>

</style>
